
export const BACKEND_URL = "https://random-emoji-generator.appspot.com/"